import React, { useEffect, useState, useContext } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';

import styles from '../assets/styles/DrawDown.module.scss';
import Breadcrumb, { BreadcrumbItem } from '../components/Breadcrumb';
import CreditLineRecentActivitiesTable from '../components/CreditLine/CreditLineRecentActivitiesTable';
import Layout from '../components/common/Layout';
import { UserContext } from '../context/UserContext';
import { getLoanActivities, getLoans } from '../service/loan';

const CreditLineRecentActivities = () => {
  const [loans, setLoans] = useState([]);
  const [activities, setActivities] = useState([]);
  const { loading, setLoading } = useContext(UserContext);
  const params = useParams();
  const loanId = params.id;
  const navigate = useNavigate();
  useEffect(() => {
    const loadActivities = async (id) => {
      try {
        const res = await getLoanActivities(id);
        const activities = res.data.reverse();
        setActivities(activities);
      } catch (e) {
        console.log('error', e);
        navigate('/dashboard');
      } finally {
        setLoading(false);
      }
    };
    loadActivities(loanId);
  }, [loans]);
  useEffect(() => {
    const loadLoans = async () => {
      setLoading(true);
      try {
        const {
          data: { data },
        } = await getLoans();

        setLoans(data);
      } catch (e) {
        console.log(e);
        navigate('/dashboard');
      }
    };
    loadLoans();
  }, []);

  const renderContent = () => {
    return (
      <>
        {!loading && (
          <div className={`${styles.DrawDown} ${styles.activitiesPage}`}>
            <Breadcrumb className={styles.DrawDown__breadcrumb}>
              <BreadcrumbItem>
                <Link to={`/dashboard`}>Line of Credit</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>View Activities</BreadcrumbItem>
            </Breadcrumb>
            <h3 className={styles.tableTitle}>Recent Activity</h3>
            <div className={styles.activitiesTableWrapper}>
              <CreditLineRecentActivitiesTable activities={activities} fullPage id={loanId} />
            </div>
          </div>
        )}
      </>
    );
  };

  return <Layout>{renderContent()}</Layout>;
};

export default CreditLineRecentActivities;
